import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_8465ce77-9585-4fff-bcf3-0cae1d417cf9/artifacts/w0kkj7ub_WhatsApp_Image_2026-02-27_at_19.16.07-removebg-preview%20%282%29.png";

const NAV = [
  { label: "Home", path: "/" },
  { label: "I Nostri Veicoli", path: "/veicoli" },
  { label: "Chi Siamo", path: "/chi-siamo" },
  { label: "Contatti", path: "/contatti" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "glass-header border-b border-black/[0.06]"
          : "bg-white/90 backdrop-blur-md border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3 group">
          <img
            src={LOGO_URL}
            alt="Minicarmobilità"
            className="h-12 w-12 rounded-full bg-black ring-1 ring-black/10 transition-all"
          />
          <div className="leading-tight">
            <div className="font-heading text-xl md:text-2xl font-bold tracking-tight text-[#1c1f1a]">
              Minicar<span className="text-[#5ab500]">mobilità</span>
            </div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-[#7a7f77]">
              Mobility Dealer · Milano
            </div>
          </div>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-1">
          {NAV.map((item) => {
            const active = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={`relative px-5 py-2 text-sm font-semibold tracking-wide transition-colors ${
                  active ? "text-[#5ab500]" : "text-[#1c1f1a] hover:text-[#5ab500]"
                }`}
              >
                {item.label}
                <span
                  className={`absolute left-1/2 -translate-x-1/2 bottom-0 h-0.5 rounded-full transition-all ${
                    active ? "w-8 bg-[#5ab500]" : "w-0 bg-transparent"
                  }`}
                />
              </Link>
            );
          })}
          <a
            href="tel:+393297452439"
            data-testid="header-phone"
            className="ml-3 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1c1f1a] text-white text-xs font-semibold hover:bg-[#5ab500] transition"
          >
            <Phone size={12} /> 329 745 2439
          </a>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((s) => !s)}
          className="md:hidden p-2 rounded-lg border border-black/10 hover:border-[#5ab500] transition"
          aria-label="Menu"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden border-t border-black/[0.06] bg-white/95 backdrop-blur-xl"
        >
          <div className="px-6 py-4 flex flex-col gap-1">
            {NAV.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                data-testid={`mobile-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={`px-4 py-3 rounded-lg text-sm font-semibold transition ${
                  location.pathname === item.path
                    ? "bg-[#5ab500]/10 text-[#5ab500]"
                    : "text-[#1c1f1a] hover:bg-black/5"
                }`}
              >
                {item.label}
              </Link>
            ))}
            <a
              href="tel:+393297452439"
              className="mt-2 flex items-center justify-center gap-2 px-4 py-3 rounded-lg bg-[#1c1f1a] text-white text-sm font-semibold"
            >
              <Phone size={14} /> Chiama 329 745 2439
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
